/* Predefined answers only. Personal messages use Shopify's native contact form. */
(function () {
  function bindContact() {
    document.querySelectorAll('[data-sealioo-contact]').forEach(function (root) {
      if (root.dataset.contactBound) return;
      var dialog = root.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      root.dataset.contactBound = 'true';
      var opener;
      var triggers = root.querySelectorAll('[data-sealioo-contact-open]');
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          opener = trigger;
          if (!dialog.open) dialog.showModal();
          trigger.setAttribute('aria-expanded', 'true');
        });
      });
      root.querySelector('[data-sealioo-contact-close]').addEventListener('click', function () { dialog.close(); });
      dialog.querySelectorAll('a[href]').forEach(function (link) {
        link.addEventListener('click', function () { dialog.close(); });
      });
      dialog.addEventListener('close', function () {
        triggers.forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'false'); });
        if (opener) opener.focus({preventScroll:true});
      });
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    });
  }
  function bindHelp() {
    bindContact();
    document.querySelectorAll('[data-sealioo-help]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = 'true';
      var dialog = root.querySelector('dialog');
      var open = root.querySelector('[data-sealioo-help-open]');
      var close = root.querySelector('[data-sealioo-help-close]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      open.addEventListener('click', function (event) {
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
        open.setAttribute('aria-expanded', 'true');
      });
      close.addEventListener('click', function () { dialog.close(); });
      dialog.querySelectorAll('a[href]').forEach(function (link) {
        link.addEventListener('click', function () { dialog.close(); });
      });
      dialog.addEventListener('close', function () {
        open.setAttribute('aria-expanded', 'false');
        open.focus({ preventScroll: true });
      });
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      var observer = new MutationObserver(function () {
        open.hidden = !!document.querySelector('dialog[open]');
      });
      observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    });
    var result = document.querySelector('[data-sealioo-form-result]');
    if (result) result.focus({ preventScroll: false });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindHelp, { once: true });
  else bindHelp();
  document.addEventListener('shopify:section:load', bindHelp);
})();

